<!-- ./src/pages/admin/Products.vue -->

<template src="./Devedores.html"></template>

<script>
  import moment from "moment";
  import { mapMutations } from "vuex";
  import usuario from "@/services/usuario";
  import devedores from "@/services/devedores";


  export default {
    name: 'home',
    data () {
      return {
        message: '',
        search: '',
        tipo: 'cpf',
        dialogError: false,
        dialogConfirmation: false,
        dialogDevedor: false,
        editando: false,
        user: null,
        excluindo: {},
        devedores: [],
        carregando: false,
        
        maskCPF: '###.###.###-##',
        maskCNPJ: '##.###.###/####-##',
        totalDevedores: 0,
        desserts: [],
        loading: true,
        options: {},
        menu2: false,
        date2: new Date().toISOString().substr(0, 10),
        model: { },
        headers: [{
            text: 'Nome',
            align: 'left',
            sortable: true,
            value: 'Nome'
          },
          {
            text: 'Endereco',
            align: 'left',
            sortable: true,
            value: 'Endereco'
          },
          { text: 'Ações', value: 'action', sortable: false },
        ]
      }
    },
    async created () {
      
      this.user = await usuario.getUsuario(this.$store.getters.user._id);
      // this.devedores = await devedores.getPagination(this.options);
      // this.totalDevedores = this.devedores.length;
    },
    computed: {
      computedDateFormatted2 () {
        return this.formatDate(this.date2)
      },
    },
    watch: {
      options: async function () {
        await this.getDataFromApi();
        // this.devedores = await devedores.getDevedores();
        // this.totalDevedores = this.devedores.length;
      },
      date2 (val) {
        this.dateFormatted2 = this.formatDate(this.date2)
        this.model.DataNascimento = this.date2;
      },
    },
    methods: {
      
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      getDataFromApi: async function () {
        this.loading = true;
        
        //this.setLoading(true);
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        this.options.search = this.search;
        let items = await devedores.getPagination(this.options);

        if (sortBy.length === 1 && sortDesc.length === 1) {
          items.data = items.data.sort((a, b) => {
            const sortA = a[sortBy[0]]
            const sortB = b[sortBy[0]]

            if (sortDesc[0]) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }
        
        this.devedores = items.data;
        this.totalDevedores = items.count;
        //this.setLoading(false);
        this.loading = false;
      },
      save: async function () {
        let errors = await this.$validator.validate();
        if (errors) {
          let res = await devedores.save(this.model);
          if (res.data && res.data.error) {
            this.message = res.data.error.data;
            this.dialogError = true;
          } else {
            this.model = {}
            this.dialogDevedor = false;
            await this.getDataFromApi();
            //this.devedores = await devedores.getDevedores();
          }
          
        }
      },
      
      deleteItem: async function (even) {
        if (!this.dialogConfirmation) {
          this.dialogConfirmation = true;
          this.excluindo = even;
        } else {
          await devedores.remove(even);
          this.dialogConfirmation = false;
          this.excluindo = null;
          await this.getDataFromApi();
        }
      },
      clear: async function () {
        this.model = {}
        this.editando = false;
        this.dialogDevedor = false;
        await this.getDataFromApi();
      },
      novo: function () {
        this.model = {};
        this.dialogDevedor = true;
      },
      editItem: async function (even) {
        
        this.dialogDevedor = true;
        this.editando = true;
        this.model = even;
        
        this.model.internal = undefined;
        this.model.flags = undefined;
        if (this.model.DataNascimento) {
          this.date2 = new Date(this.model.DataNascimento).toISOString().substr(0, 10);
        } else {
          this.date2 = null;
        }
      },
      ...mapMutations({
        setLoading: "setLoading",
        setDevedor: "setDevedor",
      }),
      

    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/devedores/Devedores.vue